import React from 'react';
import { map } from 'lodash';
import PaymentMethodItem from './PaymentMethodItem';
import Label from '../../../../shared/components/I18n/Label';

const PaymentMethodList = ({ payments, route, type, active = null, children }) => (
  <>
    <h3><Label message={`${type.toLowerCase()}_method`} /></h3>
    <div className='payments'>
      {map(payments, ({ id, name, depositType }) => (
        <PaymentMethodItem
          key={id}
          id={id}
          depositType={depositType}
          name={name}
          route={route}
        />
      ))}
    </div>
    {active && children}
  </>
);

export default PaymentMethodList;
